import React from "react";
import "../assets/css/productdesc.css";
import toiletPic from "../assets/images/products/bussniss-pic.jpeg";
import Accordion from "react-bootstrap/Accordion";
import Container from "react-bootstrap/Container";

const accessories = [
  {
    title: "Coin mechanism/Touch free button/Smartcard:",
    disc: "Coin mechanism with coin denominations of Rs.1/2/5 are commonly used in jaladhija smart toilet unit. Some special group usages can be given button operation or smartcards. For example, metro cards can be customized to be used as an entry card to jaladhija.",
  },
  {
    title: "Touch free wash basin:",
    disc: "A wall mounted basin range providing the perfect solution for areas that require a touch free hygienic hand washing facility. Robust construction from stainless steel provides durability and the innovative space saving design allows installation into new build or retro fit situations. Economic soap and water consumption and high speed hand drying ensures efficient touch free hand cleansing. With no exposed plumbing the basins are suitable for all locations. A water tempering option provides the ability to control the water to a desired preset temperature level. Front and rear access models are available.",
  },
  {
    title: "Pre-flush/ Auto flush system:",
    disc: "This is an important accessory included in jaladhija. The systems have a sensor to detect human body and it calculates time spent on toilet pan and flushes accordingly. The system has a manual button to flush toilet manually. Also the system wets the toilet pan while user starts using the system.",
  },
  {
    title: "Sanitary Disposal Unit:",
    disc: "An efficient system providing a discrete and robust disposal facility for sanitary napkins. Hygienic, easy clean and vandal resistant stainless steel design open to service room.",
  },
  {
    title: "Multi Angle Hooks:",
    disc: "Durable stainless steel hooks, designed with safety in mind providing a curved finish, special angle and no sharp edges",
  },
  {
    title: "Manual tower bolt inside:",
    disc: "Stainless steel tower bolts inside to lock the toilet door manually with durable design and no sharp edges.",
  },
  {
    title: "Mirror:",
    disc: "Glass or optional world famous Aranmula metal mirror can be provided inside.",
  },
  {
    title: "European or Indian style Toilet Pan:",
    disc: "jaladhija smart toilet normally have Indian style stainless steel polished toilet pan mainly due to hygienic touch less usage in public toilets. Altersoft can provide European pan as requested.",
  },
  {
    title: "Stainless steel health faucet or mug:",
    disc: "Health faucets are easy to be tampered so we included normal law height tap and mug inside jaladhija.",
  },
  {
    title: "Structure and Fabrication:",
    disc: "At most care is taken to design its body fabrication tamper proof and rust proof. It is portable in whole or packed to install at site. It has different sizes as per number of usage units in a single console. It never lets a person trapped inside as there is only manual locking of the toilets once a person comes inside. Tamper proof fasteners with stainless steel 304 grade facades of walls and roof, and bottom 316 grade 3mm stainless steel sheets with perforation, ensures hygiene at public usage. At most care has given to usage of water and power. There are optional features like air conditioner, solar panels and bio membrane tank..",
  },
  {
    title: " Software and online monitoring:",
    disc: "We offer software for supervisory control over all installed jaladhija smart toilet. A GPRS system installed inside the toilets can transmit data like its usage, cleaning, sensor status to a remote computer. This in turn can monitor using web interface we provide. This can be used by supervisors or municipal authorities to ensure its proper operations. They can remotely on or off the system to prevent unwanted usage. There shall be a group of installations at different locations in city and USI will provide online software with a user name and password to the supervising team. The software will give right to operate the jaladhija remotely and get a report of usage. The supervisors can program jaladhija operating time, floor cleaning frequency, and can attend any alert conditions.",
  },
  {
    title: " Pressure Cleaning:",
    disc: "There is unique feature like pressure cleaning with spiral nozzles to ensure even water jet cleaning at usable area of toilet floors and walls with reduced water usage.",
  },
  {
    title: " Pre-flush mechanism:",
    disc: "Most of the times, toilet hygiene is compromised since users may not wet the toilet pan before using it. Our IPtoilet employs pre-flush mechanism that wets the pan before every use automatically. This makes it possible to clean the pan in a single flush from the cistern. Pre-flush is an age old technique of wetting the toilet pan before every usage. The inbuilt automation initiates a very quick and limited flush to wet the pan before usage. Therefore the waste does not stick to the surface and normal flush is adequate for cleaning. Water usage for cleaning also will be a minimum.",
  },
  {
    title: " Self Cleaning using pressure jet spray:",
    disc: "We never fail to maintain toilet hygiene at our home, but that is not the case in public toilets. On top is the acute shortage of labour for cleaning lavatories. The timed pressure sprayers, perforated floors, auto-flush and the stainless steel body helps in self-cleaning of our toilets.",
  },
  {
    title: " Automated for minimum user contact:",
    disc: "It is commonly observed in public toilets that people tend to spoil the door handle, switches, tap knobs, or flush knobs by rough use. By automating these operations, there is no need for any manual intervention except manually bolting the door from inside. It ensures minimum user contact and thus maximum hygiene.",
  },
  {
    title: " Optimized and efficient use of resources:",
    disc: "The water and power supply is a depleting resource and therefore the wastage of such valuable resources in public toilets is an additional pressure on the suppliers. Our toilets optimize the usage of water by pre-flush, pressure flush, and pressure spray.",
  },
  {
    title: " Unique design for hygiene:",
    disc: "We believe in addition to self-cleaning mechanism, it is very important to have a system that supports effective cleaning. We have developed a unique design that makes cleaning effective. For e.g., our floors are perforated and tilted to ensure all the grime from foot wears does not remain on the floor surface.",
  },
  {
    title: " Never Locked inside:",
    disc: "Once get inside, the user can manually bolt and unbolt the door from inside. So there is absolutely no chance that a user can get stuck inside. The door is designed for emergencies such as this, where it can be opened by any person from outside with a telephonic direction. You can find simple instructions on every jaladhija.",
  },
  {
    title: "Durability:",
    disc: "The interior of the toilet is stainless steel 304 grade 1.5 mm thickness wall and top cladding (facade ) and floor is made up of 316 grade stainless steel 3mm perforated sheet. Outside usually made up of aluminum composite panel with 4mm thickness. The life expectancy of these public toilets is 15 to 20 years after which it may require an overhaul to be reinstated.",
  },
  {
    title: " Cleaning and hygiene:",
    disc: "Intelligent public toilets are designed for self cleaning using water jet system. It cleans the floor and wall of SS cladded inside body. USI can offer water repellent coating as additional option to add its hygiene. It also has provision for manual cleaning using pressure cleaners for outer area cleaning. There is waste bin inside which opens to service area. It is advisable to do the waste bin clearance regularly, pressure water cleaning of foot steps and outer area, coin collection, etc. The cleaning frequency of the automated system can be adjusted according to client requirement.",
  },
  {
    title: " Provision for revenue generation:",
    disc: "Generally public toilets are kept in nooks and corners where there is no scope for advertisement. But the outer elevation can be customized to offer advertisement if requested. Further there is coin collection which can be used as a revenue making system. There is a possibility like a small utility shop or ATMs in areas where it requires.",
  },
  {
    title: " Waste treatment options:",
    disc: "The waste is usually connected to the sewage line provided by the local authorities. However in places where there is no scope of any sewage line, we provide bio-membrane tanks which can separate fecal matter into bio-waste and grey water that is completely odorless. Biomembrine tank is specially treated bacteria driven environmentally effective grey water treatment system which decomposes bio-waste into gas and odorless clean water.",
  },
  {
    title: " The water conservation method used:",
    disc: "Intelligent public toilet cleans its wall and floor frequently and automatically but the system uses high pressure water jet cleaning without using any harmful cleaning solutions. The pressure cleaning of fifteen or twenty seconds make sure minimum required water usage. It also uses sensor tape and sensor flushing which also ensures minimum usage of water. Water repellent coating inside toilet floor and walls also seems effective for water conservation in public toilets.",
  },
  {
    title: " Optional features:",
    disc: "If there is a scarcity of steady power options at the venue of installation, you can option for solar panel power generation as a backup. Audio/Video systems can be introduced to read out instructions or even play advertisements for revenue generation. We provide an option to install climate control systems for units installed at extreme hot or arid environment for user comfort. Timed aromatic dispenser will maintain a pleasant aroma inside the IPtoilet and make the duration of occupancy very comfortable. Mothers with toddlers would find it convenient to have a feeding or napkin changing platform inside jaladhija for emergencies. Some users like old citizens, handicapped, or carrying mothers would find it very useful to have a user support system for sitting and rising. We generally provide pan toilets to ensure minimum body contact in public toilets. However a European seat model toilet can also be provided. You can specify the number of hooks and places where you would prefer to have them installed in the IPtoilet. There are options like Sanitary Napkin Vending Machine and napkin incinerator for women friendly toilets. There are various types of users and if you would prefer a tissue dispenser we would provide with a replenishable tissue dispenser.",
  },
  {
    title: " Space required installing an IPtoilet unit:",
    disc: "Intelligent public toilet installation requires minimum space for a single unit shown above plus foot step plus shield or small garden. Customers can choose outer design as per their customization. Sizes for single seated unit, double seated unit are shown at the beginning of this Products page.",
  },
];

const ProductDesc = () => {
  return (
    <>
      <section className="select-box container">
        <div id="content">
          <div className="row sidebar-page">
            <div className="left-sidebar">
              <h4 className="classic-title">
                <span>Jaladhija - Product Overview</span>
              </h4>
              <p>
                <img
                  className="img-thumbnail image-text"
                  style={{ float: "left", width: "180px" }}
                  alt=""
                  src={toiletPic}
                />
                Jaladhija are maintainable public toilets which have self
                cleaning mechanism. It saves cost in operation and maintenance
                of public toilet almost 90 percent by employing new public
                toilet service methods. Pay-per-use public toilets are effective
                only at places where there is heavy flow of people like markets,
                railway stations and bus stands. But highways and city outskirts
                are the places where public toilets are most required. But it is
                not possible to maintain these toilets with pay-per use methods
                as there will have not much users all the time. Here Jaladhija
                with its unique self cleaning mechanism, vandal proof design,
                luxurious interiors, high level of hygiene and low operational
                cost become effective. Considering cost of total ownership
                within 5 years' service cost of a Public Toilet, 70% of the cost
                will be its operational cost. Without proper maintenance, public
                toilets are useless and a health hazard to the public. But
                requirement for public toilets are increasing exponentially with
                the economic development and resulted urbanization and floating
                population. The highways, malls, airports, railway stations,
                general hospitals, stadiums, prepaid taxi counters, camping and
                training sites, tourist places, military camps, construction
                sites and public offices require Jaladhija. Altersoft will
                provide toilet units with life time service and maintenance. It
                will have online software to manage them and mobile app for
                public to find and track installed and operating toilets. The
                intelligent public toilet was designed keeping in mind of a
                specific group of users for whom safe and hygienic sanitation is
                important like women, on-site workers, city commuters,
                travelers, campers, etc. Jaladhija have electronic sensors to
                keep its hygiene even with improper usage of occupants. It keeps
                minimum water per usage compared with normal toilets. It is
                basically designed to have a clean and unattended public
                convenience facility. Daily one time attended cleaning also is a
                part of its service policy. The Altersoft developed web based
                software to monitor its status which ensures proper service of
                each unit during its service time. Jaladhija is portable and
                with variant models to help men, women and disabled. Women
                friendly Jaladhijas will have women-friendly features such as
                napkin vending machine, incinerator to destroy used napkins,
                baby stations for changing diapers and the like. Jaladhijas in
                common will have automatic sensor taps and dustbins. Fans and
                lights will start functioning once the door is opened. There
                will be a water tank inside the toilet and the door will be
                opened only if the tank has enough water. The floor cleaner will
                function automatically after four to ten visits. There is
                automatic pre-flush when a person enters inside. It has power
                and water backup for its users in case of sudden power outage or
                water discontinuation. However before the backup depletes the
                toilet will be disabled for any new entry unless the power and
                water supply resumes. Coins can be used in public places; either
                smartcards or button press can be provided to operate these
                Jaladhijas for schools, colleges and government offices who have
                a closed user group
              </p>

              {/* Divider */}
              <div
                className="hr5"
                style={{ marginTop: "30px", marginBottom: "45px" }}
              ></div>

              {/* Accordion */}
              <div className="panel-group" id="accordion"></div>
            </div>
          </div>
        </div>
      </section>
      <section className="result_faq">
        <Container>
          <div className="faqs_oneon">
            <h4>Jaladhija - List of accessories</h4>
            <div className="faqs_ques_ans">
              <Accordion defaultActiveKey="0">
                {accessories?.map((val, i) => (
                  <Accordion.Item eventKey={i.toString()} key={i}>
                    <Accordion.Header>{val?.title}</Accordion.Header>
                    <Accordion.Body>{val?.disc}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </Container>
      </section>
      <section className="last-sec">
        <div className="container">
          <h4 className="classic-title">
            <span>Downloads</span>
          </h4>
        </div>
        <div className="container">
          <div className="links">
            <a href="" className="classic-title">Brochure</a>
            <a href="" className="classic-title">Photographs</a>
            <a href="" className="classic-title">Video</a>
            <a href="" className="classic-title">Presentation</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDesc;
